export const USER_ACCOUNT_FEATURE = 'userAccount';
export const USER_ACCOUNT_CORE_FEATURE = 'userAccountCore';
